import React from 'react';
import NextButton from './NextButton';

const LuluClue: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <p>
        Go pick up your order at the counter, but feel free to look around and
        treat yourself to one of the cute keychains or some comfy underwear!
      </p>
      <img style={{ width: '100%' }} src='barcode.jpg' />
      <NextButton
        prompt='Enter last 4 numbers of the order number for your next clue:'
        acceptedClues={['1491']}
      />
    </div>
  );
};

export default LuluClue;
